import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _once from "lodash/once";
var _excluded = ["error", "name", "className"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classnames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '../../button/Button';
import { Checkbox } from '../../checkbox/Checkbox';
import { sendRegisterFormStartEvent } from '../../../../../../../client/analytics/dataLayerService';
import { FakePasswordField } from '../../../../../components/form/components/FakePasswordField';
import FinalField from '../../../../../components/form/components/finalForm/FinalField';
import FinalForm from '../../../../../components/form/components/finalForm/FinalForm';
import { shouldDisableSubmitButton } from '../../../../../components/form/components/finalForm/finalFormUtils';
import FormError from '../../../../../components/form/components/FormError';
import formSubmissionExceptionHandler from '../../../../../components/form/registration/formSubmissionExceptionHandler';
import useGetSocialOauthError from '../../../../../components/form/registration/hooks/useGetSocialOauthError';
import { fetchInvitationEmail, submitForm } from '../../../../../components/form/registration/registerFormUtils';
import { getInitialValuesFromQueryString } from '../../../../../components/form/registration/registrationUtils';
import { REGISTER_FIELDS } from '../../../../../components/form/validation/validationConstants';
import './SignupFormFields.scss';
var ErrorLabel = function ErrorLabel(_ref) {
  var error = _ref.error;
  if (!error) return null;
  if (error.name === 'required') return /*#__PURE__*/React.createElement("span", {
    className: "ErrorLabel"
  }, "Required");
  return /*#__PURE__*/React.createElement("span", {
    className: "ErrorLabel"
  }, error.message);
};
var LabeledField = function LabeledField(_ref2) {
  var children = _ref2.children,
    name = _ref2.name,
    _ref2$Input = _ref2.Input,
    Input = _ref2$Input === void 0 ? 'input' : _ref2$Input,
    onInput = _ref2.onInput;
  return /*#__PURE__*/React.createElement(FinalField, {
    field: REGISTER_FIELDS[name]
  }, function (_ref3) {
    var input = _ref3.input,
      display = _ref3.display;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames('LabeledField', {
        error: display.error
      })
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: name
    }, children, /*#__PURE__*/React.createElement(ErrorLabel, {
      error: display.error
    })), /*#__PURE__*/React.createElement(Input, _extends({}, input, {
      onInput: onInput,
      id: name,
      name: name,
      required: true,
      size: 1
    })));
  });
};
var LabeledCheckbox = function LabeledCheckbox(_ref4) {
  var name = _ref4.name,
    children = _ref4.children,
    required = _ref4.required;
  return /*#__PURE__*/React.createElement("div", {
    className: "LabeledCheckbox"
  }, /*#__PURE__*/React.createElement(FinalField, {
    field: REGISTER_FIELDS[name]
  }, function (_ref5) {
    var input = _ref5.input,
      display = _ref5.display;
    return /*#__PURE__*/React.createElement(Checkbox, _extends({}, input, {
      name: name,
      required: required,
      className: display.error ? 'error' : ''
    }), children);
  }));
};
var LegalLink = function LegalLink(_ref6) {
  var url = _ref6.url,
    children = _ref6.children;
  return /*#__PURE__*/React.createElement("a", {
    className: "LegalLink",
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children);
};
var FORM_FIELDS = Object.values(REGISTER_FIELDS);
var PasswordField = function PasswordField(_ref7) {
  var error = _ref7.error,
    name = _ref7.name,
    className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var toggleShowPassword = useCallback(function (event) {
    event.preventDefault();
    setShowPassword(function (prevShowPassword) {
      return !prevShowPassword;
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(className, 'PasswordField'),
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(FakePasswordField, null), /*#__PURE__*/React.createElement("input", _extends({}, props, {
    name: name,
    id: name,
    type: showPassword ? 'text' : 'password'
  })), /*#__PURE__*/React.createElement("button", {
    className: "password-visibility-button",
    onClick: toggleShowPassword,
    type: "button"
  }, showPassword ? 'Hide' : 'Show'));
};
var sendRegisterFormStart = _once(sendRegisterFormStartEvent);
export var SignupFormFields = function SignupFormFields(_ref8) {
  var buttonText = _ref8.buttonText;
  var oauthError = useGetSocialOauthError();
  var _useState3 = useState(function () {
      return getInitialValuesFromQueryString();
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    initialValues = _useState4[0],
    setInitialValues = _useState4[1];
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var invitationEmail;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!initialValues.inviteCode) {
            _context.next = 2;
            break;
          }
          _context.next = 1;
          return fetchInvitationEmail(initialValues.inviteCode);
        case 1:
          invitationEmail = _context.sent;
          setInitialValues(function (prevInitialValues) {
            return _objectSpread(_objectSpread({}, prevInitialValues), {}, {
              email: invitationEmail
            });
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [initialValues.inviteCode]);
  var onSubmit = useCallback(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formValues) {
      var _t;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 1;
            return submitForm(formValues);
          case 1:
            _context2.next = 3;
            break;
          case 2:
            _context2.prev = 2;
            _t = _context2["catch"](0);
            return _context2.abrupt("return", formSubmissionExceptionHandler(_t));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return function (_x) {
      return _ref0.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/React.createElement(FinalForm, {
    className: "SignupFormFields",
    onSubmit: onSubmit,
    initialValues: initialValues,
    fields: FORM_FIELDS
  }, function (formState) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "name-fields"
    }, /*#__PURE__*/React.createElement(LabeledField, {
      name: "givenName",
      type: "text",
      onInput: sendRegisterFormStart
    }, "First name"), /*#__PURE__*/React.createElement(LabeledField, {
      name: "familyName",
      type: "text"
    }, "Last name")), /*#__PURE__*/React.createElement(LabeledField, {
      name: "email",
      type: "email"
    }, "Email"), /*#__PURE__*/React.createElement(LabeledField, {
      name: "password",
      type: "password",
      Input: PasswordField
    }, "Password"), /*#__PURE__*/React.createElement("div", {
      className: "checkboxes"
    }, /*#__PURE__*/React.createElement(LabeledCheckbox, {
      name: "agreeToTerms",
      required: true
    }, "I agree to the Milanote", ' ', /*#__PURE__*/React.createElement(LegalLink, {
      url: "https://milanote.com/legal/terms-of-service"
    }, "terms"), " and", ' ', /*#__PURE__*/React.createElement(LegalLink, {
      url: "https://milanote.com/legal/privacy-policy"
    }, "privacy policy")), /*#__PURE__*/React.createElement(LabeledCheckbox, {
      name: "subscribeToProductUpdates"
    }, "Send me occasional news & updates\xA0(optional)")), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      cta: true,
      disabled: shouldDisableSubmitButton(formState)
    }, buttonText), /*#__PURE__*/React.createElement(FormError, {
      className: "primary-error",
      error: formState.submitError || oauthError,
      hide: formState.modifiedSinceLastSubmit || formState.submitting
    }));
  });
};